module.exports = __webpack_public_path__ + "static/media/3_6.fff28379.png";